import React, { useEffect, useState } from "react";
const CreateNewList = ({
  closeTray,
  parentCloseTray,
  handleCreateNewList,
  newListName,
  setNewListName,
  error,
  setError,
  loading,
  isSubmitted,
  setIsSubmitted,
}) => {
  useEffect(() => {
    if (isSubmitted) {
      closeTray();
      if (parentCloseTray) parentCloseTray();
    }
  }, [isSubmitted]);
  useEffect(() => {
    return () => {
      setNewListName("");
      setIsSubmitted(false);
      setError("");
    };
  }, []);

  return (
    <div style={{ paddingTop: "12px" }}>
      <form
        className="d-flex flex-column p-0"
        style={{ gap: "18px" }}
        onSubmit={(e) => {
          e.preventDefault();
          if (newListName?.length > 0) handleCreateNewList();
        }}
      >
        <input
          type="text"
          className="w-100 border-0"
          style={{
            fontFamily: "Inter",
            height: "43px",
            padding: "0px 12px",
            borderRadius: "8px",
          }}
          placeholder="Create list"
          value={newListName}
          onChange={(e) => {
            setError("");
            setNewListName(e.target.value);
            if (/^\d+$/.test(e.target.value)) {
              setError("List name cannot be completely numeric");
            } else if (/[!@#$%^&*,.?":{}|<>\=+[\;()/]/.test(e.target.value)) {
              setError("List name cannot contain special characters");
            }
          }}
        />

        <button
          type="submit"
          className="btn btn-primary"
          style={{ fontFamily: "Inter", height: "42px", borderRadius: "8px" }}
          disabled={
            newListName?.length === 0 || error || newListName[0] === " "
          }
        >
          {loading ? (
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div>Create</div>
          )}
        </button>
      </form>
      <div
        className="text-danger ms-2 mt-2"
        style={{
          fontSize: "0.9rem",
          minHeight: "20px",
          transition: "opacity 0.3s",
          opacity: error ? 1 : 0,
        }}
      >
        {error}
      </div>
    </div>
  );
};

export default CreateNewList;
